import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="chartjs"
export default class extends Controller {
  static values = { type: String, data: Object, options: Object }

  connect() {
    const options = this.buildOptions()

    this.chart = new Chart(this.element, {
      type: this.typeValue,
      data: this.dataValue,
      options
    })

  }

  disconnect() {
    this.chart?.destroy()
  }

  buildOptions() {
    const sourceOptions = this.optionsValue || {}
    const clonedOptions = JSON.parse(JSON.stringify(sourceOptions))
    const datasets = this.dataValue?.datasets || []
    const numericValues = datasets
      .flatMap((dataset) => dataset.data || [])
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value))

    const maxValue = numericValues.length > 0 ? Math.max(...numericValues) : 0
    const baseScales = clonedOptions.scales || {}
    const baseYScale = baseScales.y || {}
    const baseTicks = baseYScale.ticks || {}
    const stepSize = baseTicks.stepSize ?? this.calculateStepSize(maxValue)

    return {
      ...clonedOptions,
      scales: {
        ...baseScales,
        y: {
          ...baseYScale,
          beginAtZero: true,
          min: 0,
          ticks: {
            ...baseTicks,
            stepSize,
            precision: 0,
            callback: (value) => (Number.isInteger(value) ? value : null)
          }
        }
      }
    }
  }

  calculateStepSize(maxValue) {
    // 最大値に応じて整数ステップを算出する
    if (maxValue <= 5) {
      return 1
    }

    const roughStep = Math.ceil(maxValue / 5)
    const magnitude = 10 ** Math.floor(Math.log10(roughStep))
    const normalized = roughStep / magnitude

    if (normalized <= 2) {
      return 2 * magnitude
    }

    if (normalized <= 5) {
      return 5 * magnitude
    }

    return 10 * magnitude
  }
}
